import script from "./modal_edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_edit.vue?vue&type=script&setup=true&lang=ts"

import "./modal_edit.vue?vue&type=style&index=0&id=54789ce5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54789ce5"]])

export default __exports__